import React from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Main from './layouts/Main/Main'
import Login from './components/Login/Login'
import NotFound from './views/404';
const hist = createBrowserHistory();
const theme = createMuiTheme({
  direction: 'rtl', // Both here and <body dir="rtl">
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router history={hist} alert={alert}>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/"  component={Main}/>  
          <Route component={NotFound} />  
        </Switch>
      </Router>
    </ThemeProvider>
  );
}

export default App;
